// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/.pnpm/css-loader@5.2.7/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "[data-v-6700e2c1] .navbar-explore .navbar-item{height:4.5rem}[data-v-6700e2c1] .navbar-explore .o-drop__menu{margin:0}[data-v-6700e2c1] .navbar-explore .o-drop__item{padding:1.5rem 2rem;min-width:18.75rem}[data-v-6700e2c1] .navbar-explore .o-drop__item:hover{background-color:unset}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
module.exports = ___CSS_LOADER_EXPORT___;
